export default __webpack_public_path__ + "static/media/clarksville1.4deb1ee4.png";